module.exports = __webpack_public_path__ + "img/made.8c3ac88b.svg";